module.exports = __webpack_public_path__ + "img/screen2.52b3fced.png";